import { Dto, DtoInclude } from "../../store/dto/dto";

export class BaseObjectDto extends Dto {
    @DtoInclude
    id: string;

    @DtoInclude
    created: string;
    createdBy: string;

    serverCreated: string;
    serverCreatedBy: string;

    @DtoInclude
    modified: string;
    modifiedBy: string;

    serverModified: string;
    serverModifiedBy: string;
}



// WEBPACK FOOTER //
// ./src/core/business-objects/base-object/base-object.dto.ts